import { Stack, Title } from '@mantine/core';

export function NotFoundPage() {
  return (
    <Stack gap={40} className="w-[544px] max-w-full" mx="auto">
      <img src="https://i.imgur.com/Qx8xxE1.png" alt="Page not found" />
      <Title order={1} ta="center" fw={600} fz={36}>
        Oops, the page you’re looking for isn’t here.
      </Title>
    </Stack>
  );
}
